<form [formGroup]="identifierForm">
  <igx-input-group #inputGroup
                   class="input-group"
                   [igxToggleAction]="dropDown">
    <input #input
           type="text"
           igxInput
           [igxDropDownItemNavigation]="igxDropDown"
           [ngClass]="{'is-invalid': identifierForm.get('ComboValue').errors && identifierForm.get('ComboValue').touched}"
           formControlName="ComboValue"
           readonly="readonly"
           placeholder="{{ ComboPlaceHolder }}"
           (keydown.ArrowDown)="openDropDown()" />
  </igx-input-group>

  <igx-drop-down #dropDown [width]="'100%'"
                 (onSelection)="onSelection($event)">
    <div class="drop-down__scroll-container">
      <igx-drop-down-item *ngFor="let item of items"
                          [value]="item.Description">
        {{ item.Description }}
      </igx-drop-down-item>
    </div>
  </igx-drop-down>
</form>
